import { render, staticRenderFns } from "./project-transaction.vue?vue&type=template&id=559e5112&scoped=true"
import script from "./project-transaction.vue?vue&type=script&lang=js"
export * from "./project-transaction.vue?vue&type=script&lang=js"
import style0 from "./project-transaction.vue?vue&type=style&index=0&id=559e5112&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559e5112",
  null
  
)

export default component.exports